import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';

import { Observable } from 'rxjs/Rx';

import { Link } from '../link.model';
import { Campaign } from '../../campaigns/campaign.model';
import { LinkService } from '../link.service';

declare var $: any;

@Component({
  selector: 'wm-link-list',
  template: require('./link-list.component.html')
})

export class LinkListComponent implements OnChanges {
  @Input() campaign: Campaign;

  public requests: Array<any>;
  public checkids = {};

  links: Link[];
  loading = true;

  constructor(
    private service: LinkService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!this.campaign) {
      this.links = this.campaign.links;

      if (this.links.length > 0) {
        this.checkids = {};

        this.links.forEach((item, index) => {
          this.checkids[item['id']] = true;
        });

        this.getLinkStatistic();
      }

      this.loading = false;
    }
  }

  updateLinkStatistic() {
    this.getLinkStatistic();
  }

  listCountUpdate(items_block) {
    let items = items_block['links'];

    Object.keys(items).forEach(metric => {
      this.campaign.links.forEach(function(item) {
        if (!!items[metric][item['id']]) {
          $(`#${item['id']} .link-list__item__${metric}`).text(
            items[metric][item['id']]
          );
        } else {
          $(`#${item['id']} .link-list__item__${metric}`).text(0);
        }
      });
    });
  }

  getLinkStatistic() {
    this.requests = [{
      checkids: this.checkids, metrics: ['clicks', 'sessions', 'users'],
      start_date: this.campaign['created_at'], end_date: this.campaign['end_date'],
      statistic_type: 'links'
    }];
  }

  checkAll(ev) {
    Object.keys(this.checkids).forEach(item => {
      this.checkids[item] = ev.target.checked;
    });
  }

  isAllChecked() {
    return Object.keys(this.checkids).map(key => this.checkids[key]).every(_ => _);
  }

  addLinks(link) {
    link['count'] = 0;
    this.links.unshift(link);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/links/components/link-list.component.ts